import { b as S } from "../../../vee-validate.esm-c4518011.js";
import { defineComponent as g, ref as l, toRefs as k, resolveComponent as C, openBlock as i, createElementBlock as V, normalizeClass as m, renderSlot as d, createElementVNode as h, createBlock as b, withCtx as f, createTextVNode as p, toDisplayString as c, createCommentVNode as y } from "vue";
import L from "../VButton/VButton.js";
import { submitForm as O } from "../../../composables/useSubmitForm.js";
import { _ as F } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../VIcon/VIcon.js";
import "../VSpinner/VSpinner.js";
import "../../../composables/useSpacingClass.js";
import "../../../composables/useScrollTo.js";
const $ = g({
  name: "VForm",
  components: {
    VButton: L
  },
  emits: ["form:submit", "form:secondary-action"],
  props: {
    model: Object,
    autocomplete: {
      type: Boolean,
      default: !0
    },
    validationSchema: {
      type: Object,
      required: !1
    },
    submitButtonLabel: {
      type: String,
      default: ""
    },
    secondaryButtonLabel: {
      type: String,
      default: ""
    },
    submitButtonDisabled: {
      type: Boolean,
      default: !1
    },
    submitButtonLookSecondary: {
      type: Boolean,
      default: !1
    },
    isSubmitting: {
      type: Boolean,
      default: !0
    },
    isFormInvalid: {
      type: Boolean,
      default: !0
    },
    buttonsInline: {
      type: Boolean,
      default: !1
    },
    disableSubmitButtonOnError: {
      type: Boolean,
      default: !1
    },
    validateOnMount: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { emit: o }) {
    const t = l({}), { validationSchema: s } = k(e), r = l(null), {
      resetForm: u,
      isSubmitting: n,
      values: a,
      errors: B
    } = S({
      validationSchema: s,
      validateOnMount: e.validateOnMount
    });
    return {
      onSubmit: O(r, a, (v) => {
        t.value = {
          ...t.value,
          ...v
        }, u({
          values: {
            ...t.value
          }
        }), o("form:submit", t.value);
      }),
      validating: n,
      secondaryButtonClicked: () => {
        o("form:secondary-action", t.value);
      },
      formRef: r,
      errors: B,
      enteredValues: a
    };
  }
});
const _ = ["autocomplete"];
function D(e, o, t, s, r, u) {
  const n = C("VButton");
  return i(), V("form", {
    class: m(["hobi-form", { "hobi-form--submitting": e.isSubmitting }]),
    autocomplete: e.autocomplete ? "on" : "off",
    onSubmit: o[0] || (o[0] = (...a) => e.onSubmit && e.onSubmit(...a)),
    ref: "formRef"
  }, [
    d(e.$slots, "default", {}, void 0, !0),
    h("div", {
      class: m(["hobi-form-buttons-container", { "hobi-form-buttons--inline": e.buttonsInline }])
    }, [
      e.submitButtonLabel !== "" ? (i(), b(n, {
        key: 0,
        "is-loading": e.isSubmitting || e.validating,
        order: e.submitButtonLookSecondary ? "secondary" : "primary",
        type: "submit",
        disabled: e.submitButtonDisabled || e.disableSubmitButtonOnError && Object.keys(e.errors).length > 0
      }, {
        default: f(() => [
          p(c(e.submitButtonLabel), 1)
        ]),
        _: 1
      }, 8, ["is-loading", "order", "disabled"])) : y("", !0),
      e.secondaryButtonLabel !== "" ? (i(), b(n, {
        key: 1,
        order: "secondary",
        type: "button",
        onClick: e.secondaryButtonClicked,
        disabled: e.isSubmitting
      }, {
        default: f(() => [
          p(c(e.secondaryButtonLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])) : y("", !0)
    ], 2),
    d(e.$slots, "form:secondaryAction", {}, void 0, !0)
  ], 42, _);
}
const G = /* @__PURE__ */ F($, [["render", D], ["__scopeId", "data-v-7bbb596e"]]);
export {
  G as default
};
